export default __webpack_public_path__ + "static/media/criminal.8a055729.png";